import React from 'react';
import getComponentClassNames from '../../utils/className/getComponentClassNames';
import { Image } from '../../components/Image';
import { BlockLink, MaskedLink } from '../../components/Link';
import Box from '../../components/Box/Box';
import ActionIcons from '../../components/Image/ActionIcons';

const classNames = getComponentClassNames(['StructuredListing', { modifiers: 'vertical' }], ['body', 'title']);

type TFavoriteButton = {
  onHeart?: () => void;
  isFavorite: boolean;
};

function getFavoriteData(isFavorite: boolean) {
  if (isFavorite) {
    return {
      icon: 'heart_filled',
      ariaLabel: 'Favorite',
      color: 'signal-error-default',
    };
  }
  return {
    icon: 'heart',
    ariaLabel: 'Unfavorite',
    color: '',
  };
}

const FavoriteButton = ({ onHeart, isFavorite = false }: TFavoriteButton) => {
  return (
    <Box name="image-Action-icons" as="div" className="hz-Image-icons">
      <ActionIcons onClick={() => onHeart?.()} tabIndex="0" {...getFavoriteData(isFavorite)} />
    </Box>
  );
};

type TStructuredListingProps = {
  title: string;
  price: string;
  imageSrc?: string;
  imageLoading?: 'lazy' | 'eager' | undefined;
  decoding?: 'sync' | 'async' | 'auto' | undefined;
  currency?: string;
  imageOverlayLabel?: string;
  className?: string;
  alt?: string;
  onError?: () => void;
  isMaskedLink?: boolean;
  url?: string;
  onClick?: () => void;
  onContextMenu?: () => void;
  onHeart?: () => void;
  isFavorite?: boolean;
  showFav?: boolean;
};

const StructuredListing = ({
  title,
  price,
  imageSrc = '',
  imageLoading,
  decoding,
  currency = '',
  url = '#',
  onClick,
  onContextMenu,
  isMaskedLink = false,
  onHeart,
  isFavorite = false,
  showFav = false,
  alt = 'image',
}: TStructuredListingProps) => {
  const LinkComponent = isMaskedLink ? MaskedLink : BlockLink;
  return (
    <article className={classNames.root}>
      <LinkComponent href={url} onClick={onClick} onContextMenu={onContextMenu}>
        <Image
          loading={imageLoading}
          decoding={decoding}
          src={imageSrc}
          alt={alt}
          fetchpriority="high"
          aspectRatio="landscape"
        />
        <div className={classNames.body}>
          <span className={classNames.title}>{title}</span>
          <div className="hz-Title hz-Title--title5">
            {currency && `${currency} `}
            {price}
          </div>
          {/* {imageOverlayLabel && <span className={classNames.imageOverlayLabel}>{imageOverlayLabel}</span>} */}
        </div>
      </LinkComponent>
      {showFav && <FavoriteButton onHeart={onHeart} isFavorite={isFavorite} />}
    </article>
  );
};

export default StructuredListing;
